"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SwitchMenuItem = void 0;
const react_1 = __importDefault(require("react"));
const icons_1 = require("../../../theme/icons");
const SwitchMenuItem_styles_1 = require("./SwitchMenuItem.styles");
const SwitchMenuItem = ({ id, title, url, img, description, titleOnly, openProduct, externalLinkClicked, }) => {
    const linkHandler = (event) => {
        event.stopPropagation();
        if (externalLinkClicked) {
            externalLinkClicked(true);
        }
    };
    return (react_1.default.createElement(SwitchMenuItem_styles_1.Wrapper, { onClick: () => openProduct && openProduct(id) },
        react_1.default.createElement(SwitchMenuItem_styles_1.IconWrapper, null,
            react_1.default.createElement("a", { href: url, target: "_blank", rel: "noreferrer external nofollow noopener", onClick: (event) => linkHandler(event) },
                react_1.default.createElement(icons_1.Launch, null))),
        react_1.default.createElement(SwitchMenuItem_styles_1.ImgWrapper, { "$titleOnly": titleOnly },
            react_1.default.createElement("img", { src: img, alt: "" })),
        react_1.default.createElement(SwitchMenuItem_styles_1.TextWrapper, null,
            react_1.default.createElement(SwitchMenuItem_styles_1.TitleWrapper, null, title),
            react_1.default.createElement(SwitchMenuItem_styles_1.DescriptionWrapper, { "$titleOnly": titleOnly }, description))));
};
exports.SwitchMenuItem = SwitchMenuItem;
//# sourceMappingURL=SwitchMenuItem.js.map